import React from "react";
import PortfolioList from "./_components/PortfolioList";
import { Helmet } from "react-helmet";
import Img from "../../assets/images/image";
import HeroSection from "../../Components/HeroSection/HeroSection";

const Portfolio = () => {
   return (
      <div className="animation fadeIn">
         <Helmet>
            <title>Portfolio - Witmates Technologies</title>
            <meta
               name="description"
               content="Take a look at our impressive portfolio showcasing expertise. Witmates delivers tangible results for businesses around the world with our innovative solutions."
            />
            <link rel="canonical" href="https://www.witmates.com/portfolio" />
         </Helmet>
         <HeroSection
            image={Img.portfolioBanner}
            heading={
               <>
                  Unveiling the{" "}
                  <span className="witmates-theme-color">
                     Portfolio <br /> Where
                  </span>{" "}
                  Innovation <br /> Meets <span className="witmates-theme-color">Excellence</span>
               </>
            }
            description={
               <>
                  Explore our exceptional portfolio and witness the impressive projects we have delivered as Witmates. We believe that actions speak louder than words. So, immerse yourself on a visual
                  journey through our portfolio and discover how we turn visions into remarkable
               </>
            }
            link
         />
         <PortfolioList />
      </div>
   );
};

export default Portfolio;
